/** These strings aren't customer-facing: these don't need to be localized. */
export const ACCESS = {
  name: 'Brock',
  companyLogoUrl:
    'https://static.wikia.nocookie.net/logopedia/images/8/8c/Pok%C3%A9mon.svg/revision/latest/scale-to-width-down/300?cb=20180728053656',
  setPasswordUrl:
    'https://staging.degreed.dev/develop/auth/Account/ResetPassword?userId=e6365f87-86b3-43bb-96f4-4fe504c80542&code=CfDJ8PN%2B3abLHAFJvkRpiKBkZHcEowQbbY7AMBM1sILVlc5PnHW6xsLFS%2FXYSuHJrdKJtzM4zzOSZDfNKjGeiblYgzJxBo264g3EohoJXK%2BfyNuvyRxU2HtXDju8vE74v8jwcENA%2Bi%2FlyRD2loKpwjus1s97hzy7n8zlfb%2F3EqZ67f%2Bsh7Bv88ZwOqdeNE0WjMIAJ%2FlEFG3WuPz%2FYxPe1KwFtfXCjSMkXxRzAIpETvI%2FxXlh&cid=learnin-react',
};
